<template>
    <div>
        <h1 >{{ getHeader }}</h1>
        <b-spinner label="Loading..." v-show="loading" variant="danger"></b-spinner>
  <b-card-group deck v-show="!loading">

    <b-card title="" header-tag="header" footer-tag="footer">
      <b-card-text v-html="getText"></b-card-text>
    </b-card>
  </b-card-group>
        </div>
</template>

<script>
export default {
  computed: {
    getText() {
      const lang = this.$store.state.calc.currentLocale;
      return this.form[lang].text;
    },
    getHeader() {
      const lang = this.$store.state.calc.currentLocale;
      return this.form[lang].header;
    },
    currentLocale() {
      return this.$store.state.calc.currentLocale;
    },
  },
  async mounted() {
    // this.loading = true;
    // try {
    //   await this.axios.get('http://fishrpc.kz/wp-json/wp/v2/pages/?id=3496&lang=any&per_page=1').then((data) => {
    //     this.form.ru.text = data.data[0].content.rendered;
    //   });
    //   await this.axios.get('http://fishrpc.kz/wp-json/wp/v2/pages/?p=3492&lang=kz&per_page=1').then((data) => {
    //     this.form.kz.text = data.data[0].content.rendered;
    //   });
    // // eslint-disable-next-line no-empty
    // } catch { } finally {
    //   this.loading = false;
    // }
  },
  data() {
    return {
      loading: false,
      form: {
        ru: {
          text: `<p><b>ТОО «Научно-производственный центр рыбного хозяйства»</b></p>

<p>Миссия НПЦ РХ - Сохранить и приумножить рыбные ресурсы Республики Казахстан и открыть новые возможности их использования.

</p><p>Видение - НПЦ РХ с помощью миссии и стратегии ставит целью достижение международного уровня в сфере рыбного хозяйства и экологии водных биоценозов.

</p><p>Стратегия НПЦ РХ - это создание системы получения научной продукции, передачи по стандартам РСМД, надежная система для достижения результатов НИР в практике рыбного хозяйства, стабильное финансовое положение, обеспеченные государственными и частными заказами НИР.

</p><p>История института началась с организации в 1929 г. в г.Аральске научной рыбохозяйственной станции Всесоюзного научно-исследовательского института рыбного хозяйства и океанографии (ВНИРО). В 1933 г. был открыт филиал этой станции в г. Балхаш, который в 1934 г. стал самостоятельной научно-исследовательской станцией ВНИРО. В 1938 г. эта станция была передана из системы ВНИРО Всесоюзного научно-исследовательского института озерного и речного рыбного хозяйства (ВНИОРХ) и преобразовано в его отделение.

</p><p>За более чем 90-летний период своей деятельности НПЦ РХ осуществляет постоянный мониторинг состояния экосистем водоемов Казахстана и их биоресурсов, разработку биологических основ рационального использования и воспроизводства рыбных запасов, дает ежегодные прогнозы объемов вылова рыбы, предложения по правилам и режиму рыболовства.

</p><p>Ежегодно на основании научно-обоснованных данных НПЦ РХ выходит Постановление Правительства по лимитам вылова рыбы из водоемов Республики.

</p><p>Накоплен многолетний банк данных по гидрологии, гидробиологии, гидрохимии, токсикологии в условиях антропогенного воздействия на экосистемы водоемов.

</p><p>Проводились акклиматизационные работы по интродукции ихтиофауны и кормовых беспозвоночных.

</p><p>Учеными НПЦ РХ была разработана стратегия рыбного хозяйства, учитывающая ущерб рыбным запасам наносимым гидростроительством, предусмотрены компенсационные рыбоводно-мелиоративные мероприятия. Совместно с производством проводились работы по озерно-товарному рыбоводству.

</p><p>Оценены запасы ценного биоресурса – рачка артемии и его цист по всей акватории минерализованных водоемов Республики Казахстан.

</p><p>Внедрялось индустриальное рыбоводство: разработаны технологии выращивания и разведения рыб с использованием теплых вод энергетических и тепловодных станций.

</p><p>Учеными-рыбоводами разработаны генеральная схема размещения рыбоводных хозяйств, биотехнология разведения и нормативная база для конкретных регионов Казахстана.

</p><p>Разработана ресурсосберегающая технология разведения рыб в поликультуре с использованием дешевых кормосмесей. Даны рекомендации по профилактике и лечению болезней рыб в прудовых и нерестово-вырастных хозяйствах, по снижению заболеваемости рыб в естественных водоемах. Проводились исследования по технике рыболовства, которые позволили предложить новые, более эффективные способы и орудия лова, машины и приспособления для механизации трудоемких процессов в рыболовстве.

</p><p>Экономические исследования были направлены на анализ хозяйственной деятельности предприятий рыбной отрасли с целью повышения их экономической эффективности и улучшения организации труда.

</p><p>С 2001 г. проводятся комплексные экологические исследования, направленные на оценку состояния водных биоресурсов трансграничных водных бассейнов. Проведено уточнение и разработаны принципы и критерии распределения водных биоресурсов между сопредельными государствами. Результаты исследований используются в работе Комиссии по водным биоресурсам Каспийского моря при межгосударственном распределении общих допустимых уловов осетровых и других промысловых рыб.

</p><p>На основе проведенных исследований и взаимодействия с научно-исследовательскими организациями прикаспийских государств выработаны общие методы оценки численности осетровых видов рыб, разработана региональная программа сохранения и устойчивого использования биоресурсов Каспийского моря.

</p><p><b>Выполняется большой объем по внебюджетным договорам, по таким направлениям как:</b></p>
<div style="padding-left: 10px;">
<ul>
 <li>Научное обеспечение ведения рыбного хозяйства на закрепленных водоемах;</li>
 <li>Паспортизация рыбохозяйственных водоемов и определения перспективных водоемов для ведения рыбного хозяйства (товарного рыбоводства, рыболовства, добычи артемии);</li>
 <li>Разработка рыбоводно-биологических обоснований создания рыбоводных хозяйств различного типа;</li>
 <li>Разработка биологических обоснований на акклиматизацию и зарыбление;</li>
 <li>Разработка биологических обоснований по расчету ущерба рыбному хозяйству от хозяйственной деятельности и рекомендаций по его снижению;</li>
 <li>Разработка методик и рыбоводно-технологических нормативов для искусственного воспроизводства и товарного выращивания новых объектов аквакультуры и большое количество других прикладных НИР.</li>
</ul>
</div>
<p><b>Стратегические направления научно-производственной деятельности института</b></p>
<div style="padding-left: 10px;">
<ul>
 <li>Получение конкурентоспособных результатов</li>
 <li>Интеграция науки, образования и производства</li>
 <li>Внедрение научных разработок</li>
 <li>Сбалансированный кадровый состав</li>
 <li>Совершенствование инфраструктуры организации</li>
 <li>Совершенствование финансовой политики</li>
</ul>
</div>`,
          header: 'О компании',
        },
        kz: {
          text: `<p><b>Институт міндеті</b></p>
<p>БШҒӨО міндеті – Қазақстан республикасының балық ресурстарын сақтау және молайта түсу, оларды пайдаланудың жаңа мүмкіншіліктерін ашу.
</p><p>Мақсаты – БШҒӨО стратегиясы мен миссиясын іске асыру арқылы балық шаруашылығы және су биоценоздарының экологиясы саласындағы халықаралық деңгейдегі ғылыми-зерттеу институты болуға ұмтылады.
</p><p>БШҒӨО-ның дейінгі стратегиясы халықаралық стандарттарға сай, ҒЗЖ алынған нәтижелерді балық шаруашылығы практикасына қолдану, тұрақты қаржылық жағдай, ҒЗЖ мемлекеттік және жеке тапсырыстармен де қамтылған ғылыми өнімді алудың жүйесін құру.
</p><p>Институттың тарихы 1929 жылдан Бүкілодақтық балық шаруашылығы және окенография ғылыми-зерттеу институтының Арал қаласындағы ғылыми балықшаруашылықтық станциясынан басталады. 1933 жылы осы станцияның филиалы Балқаш қаласында ашылды, кейіннен 1934 жылы Бүкілодақтық балық щаруашылығы және окенография ғылыми-зерттеу институтының жеке станциясы болды. 1938 жылы Бүкілодақтық балық шаруашылығы және окенография ғылыми-зерттеу институты жүйесінен Бүкілодақтық көл және өзен балық шаруашылығы ғылыми-зерттеу институтының құрамына енгізілді.
</p><p>БШҒӨО 90 жылдан бері үнемі Қазақстан су айдындарының экологиялық жүйесі мен биоресурстарына тұрақты мониторинг жасап, балық қорын ұдайы өсіріп, оны тиімді пайдалану үшін биологиялық негіздеме беріп, балық аулау тәртібі мен ережесіне ұсыныстар жасап, жыл сайын ауланатын балық көлеміне болжам беруде. 
</p><p>Жыл сайын БШҒӨО беретін ғылыми-негіздемелік мәліметтер негізінде Қазақстан су айдындарында ауланатын балық мөлшерін анықтайтын Үкімет қаулысы шығады.
</p><p>Су айдындарының экожүйесіне антропогенді әсер ету салдарынан туындайтын гидрологиялық, гидробиологиялық, ихтиологиялық, гидрохимиялық және токсикологиялық көрсеткіштер бойынша көпжылдық мәліметтер банкі жасалған.
</p><p>БШҒӨО ғалымдары гидроқұрылымдарды салу кезінде балық қорына келтірілетін зиянды анықтайтын балық аруашылығының стратегиясын жасап, оны кейін компенсациялау үшін қажет бірқатар балық өсіру-мелиоративті іс-шараларды қарастырған, өндіріспен бірге көл-тауарлы балығын өсіру жұмыстары жүргізілген.
</p><p>Қазақстан Республикасының Барлық тұзды су айдындарындағы құнды биологиялық организм – артемия шаяны мен оның циста қабықтарының қоры анықталып бағаланды. Индустриалды балық өсіру енгізілген: энергетикалық және жылу станцияларының жылы суларын пайдалану негізінде балықты өсіру және көбейту технологиялары жасалған.
</p><p>Жаңа генетикалық әдістерді химиялық мутагенез бен радиациялық гиногенезді) пайдалану арқылы жоғары өнімді тұқы және ақ дөңмаңдай тұқымдары шығарылды. Балық өсіруші ғалымдар мен балық өсіру шаруашылықтарын орнықтырудың басты схемасы мен өсіру биотехнологиясы және Қазақстанның нақты аймақтарына сай нормативті негіздемелер жасалды.
</p><p>Поликультурада арзан аралас жемді пайдалану арқылы өсірудің ресурс үнемдеу технологиясы жасалған. Тоғандар мен уылдырық шаштырып өсіретін шаруашылықтарда балық ауруларын емдеу мен оның алдын алуы бойынша зерттеу жұмысары жасалып, нәтижесінде машиналар мен балық аулаудағы ауыр механизациялық процестерді әлдеқайда оңайлататын жеңіл әрі тиімді жаңа тәсілдермен балық аулау құралдары ұсынылған.
</p><p>Экономикалық зерттеулер балық өндірісіндегі ұйымдардың шаруашылық іс-әрекеттеріне сипаттама жасай отырып, олардың экономикалық тиімділікті арттыру мен еңбекті ұйымдастыру жағдайларын жақсартуды негізгі мақсат етіп отыр.
</p><p>2001 жылдан бері трансшекаралық су алаптарындағы су биоресурстарын бағалау үшін кешенді жан-жақты экологиялық зерттеулер жүргізілуде. БШҒӨО Каспий төңірегіндегі мемлекеттерді өзге де ғылыми ұйымдармен бірге Каспий төңірегіндегі балық қорын зерттеуге негізделген мемлекетаралық зерттеу жұмыстарын жүргізеді. Зерттеу нәтижелері жалпы аулауға болатын мөлшерді анықтау кезінде, бекіре балығымен басқа да кәсіптік мәні бар балықтардың аулану мөлшерін анықтауда мемлекетаралық су биоресурстар Комиссиясының жұмысы барысында квота бөлу кезінде пайдаланылады.
</p><p>Бұрынғы жасалып келе жатқан зерттеу жұмыстары мен Каспий аймағындағы мемлекеттердің ғылыми-зерттеу ұйымдарымен біріге отырып жасаған зерттеулері негізге алынып, бекіре балық түрлерінің санын анықтау әдістемесі жасалды және Каспий теңізінің биоресрстарын сақтап, тұрақты пайдалануға негізделген рационалды бағдарлама жасалды.
</p>
<p><b>Бюджеттік емес келісім шарттар бойынша үлкен көлемдегі келесідей бағыттағы жұмыстар орындалады:</b>
</p>
<div style="padding-left:10px;">
<ul>
<li>Белгіленген суқоймаларға балық шаруашылығын басқару жөнде ғылыми қолдау көрсету;</li>
<li>Балық шаруашылығын басқару үшін балық шаруашылықтық суқоймаларды паспортизациялау және перспективті суқоймаларды анықтау (тауарлы балық өсіру, балық аулау, артемия аулау);</li>
<li>Әр түрлі типтегі балық өсіру фермаларын құру үшін биологиялық негіздеме жасау;</li>
<li>Акклиматизация және балықтандыру үшін биологиялық негіздеме жасау;</li>
<li>Шаруашылықтық қызметтердің балық шаруашылығына тигізетін зиянына биологиялық негіздеме жасау, және оның деңгейін төмендетуге рекомендациялар;</li>
<li>Аквакультураның жаңа объектілерін тауарлы өсіру және жасанды өсіру үшін, және басқа да көптеген қолданбалы ҒЗЖ әдістемелер мен техникалық нұсқаулықтар әзірлеу.</li>
</ul>
</div>`,
          header: 'Біз жайлы',
        },

      },
    };
  },
};
</script>

<style scoped>


h1 {
    position: relative;
    color: black;
    font-size: 38px;
    padding: 0 20px;
    font-weight: bold;
    border-bottom: 3px solid #00a444;
    display: inline-block;
}
.card-body {
    color:black;
    text-align: justify;
}

.card-body p {
  text-indent: 30px;
}
.card{
        max-width: 1100px;
        margin:0 auto;
}
.card-header {
    color: black;
}

.card-deck {
    margin:0 !important;
}


</style>
